<template>
  <div class="policy-page">
    <main class="container">
      <h1>CHÍNH SÁCH QUYỀN RIÊNG TƯ ỨNG DỤNG HKOIL KCLUB</h1>
      <p class="intro">Chính sách này áp dụng cho tất cả người dùng Ứng dụng HKOIL KCLUB, do Công ty TNHH TM&XD Hoàng Khải (HKOIL) phát triển và vận hành. Chúng tôi cam kết tuân thủ Nghị định số 13/2023/NĐ-CP của Chính phủ về bảo vệ dữ liệu cá nhân và các quy định pháp luật liên quan, nhằm bảo vệ quyền riêng tư và an toàn thông tin của người dùng trong suốt quá trình sử dụng ứng dụng.</p>

      <section>
        <h2>2. Thông tin chúng tôi thu thập</h2>
        <ul>
          <li>Thông tin tài khoản: Địa chỉ email.</li>
          <li>Thông tin giao dịch: Dữ liệu tích điểm KCLUB</li>
          <li>Hình ảnh và tệp tải lên: Ảnh chứng từ, hình ảnh chụp qua camera hoặc tải từ thiết bị.</li>
          <li>Thông tin thiết bị: Loại thiết bị, hệ điều hành, địa chỉ IP (chỉ dùng cho mục đích kỹ thuật và bảo mật).</li>
        </ul>
        <p>Ứng dụng KHÔNG thu thập thông tin nhạy cảm như vị trí GPS, danh bạ hoặc dữ liệu cá nhân không liên quan.</p>
      </section>

      <section>
        <h2>3. Mục đích sử dụng thông tin</h2>
        <p>Thông tin thu thập được sử dụng nhằm:</p>
        <ul>
          <li>Duy trì và cải thiện hoạt động của ứng dụng.</li>
          <li>Hỗ trợ người dùng trong quá trình tích điểm, tra cứu và quản lý đơn hàng.</li>
          <li>Xác thực tài khoản, đảm bảo an toàn và phòng chống gian lận.</li>
          <li>Gửi thông báo về chương trình khách hàng thân thiết, khuyến mãi hoặc cập nhật chính sách mới (khi người dùng đồng ý).</li>
        </ul>
      </section>

      <section>
        <h2>4. Chia sẻ thông tin</h2>
        <p>Chúng tôi không chia sẻ, tiết lộ hoặc bán thông tin cá nhân của người dùng cho bất kỳ bên thứ ba nào, trừ các trường hợp:</p>
        <ul>
          <li>Theo yêu cầu của cơ quan nhà nước có thẩm quyền theo quy định pháp luật.</li>
          <li>Khi cần thiết để cung cấp dịch vụ (ví dụ: nhà cung cấp dịch vụ lưu trữ đám mây hoặc gửi thông báo qua email), với điều kiện các đối tác này tuân thủ nguyên tắc bảo mật tương đương với HKOIL.</li>
        </ul>
      </section>

      <section>
        <h2>5. Quyền của người dùng</h2>
        <p>Người dùng có quyền:</p>
        <ul>
          <li>Xem, cập nhật và chỉnh sửa thông tin tài khoản cá nhân.</li>
          <li>Gửi yêu cầu xóa tài khoản hoặc xóa dữ liệu cá nhân qua email hỗ trợ.</li>
          <li>Liên hệ HKOIL khi phát hiện có dấu hiệu rò rỉ, lạm dụng hoặc vi phạm dữ liệu cá nhân.</li>
        </ul>
        <p>Mọi yêu cầu hoặc phản ánh sẽ được HKOIL phản hồi trong vòng 07 (bảy) ngày làm việc kể từ khi nhận được.</p>
      </section>

      <section>
        <h2>6. Lưu trữ và bảo mật thông tin</h2>
        <p>Dữ liệu người dùng được lưu trữ an toàn trên hệ thống máy chủ bảo mật đặt tại Việt Nam do HKOIL quản lý hoặc các đơn vị được ủy quyền có năng lực tương đương.</p>
        <p>HKOIL áp dụng các biện pháp kỹ thuật tiên tiến như mã hóa dữ liệu, kiểm soát truy cập, sao lưu định kỳ và giám sát an ninh để ngăn chặn truy cập trái phép, mất mát hoặc thay đổi dữ liệu.</p>
        <p>Thông tin cá nhân sẽ được lưu trữ trong suốt thời gian tài khoản hoạt động và tối đa 24 tháng kể từ khi người dùng yêu cầu xóa tài khoản.</p>
      </section>

      <section>
        <h2>7. Quyền truy cập của ứng dụng</h2>
        <p>HKOIL Connect có thể yêu cầu một số quyền truy cập cần thiết, bao gồm:</p>
        <ul>
          <li>Camera: Chụp và tải lên hình ảnh chứng từ, hóa đơn hoặc quét QR code.</li>
          <li>Bộ nhớ thiết bị: Lưu hoặc tải ảnh phục vụ cho giao dịch.</li>
        </ul>
        <p>Các quyền này chỉ được kích hoạt khi người dùng đồng ý và có thể được thu hồi bất cứ lúc nào trong phần Cài đặt quyền riêng tư của thiết bị.</p>
      </section>

      <section class="contact">
        <h2>8. Liên hệ</h2>
        <p>Nếu có thắc mắc, phản ánh hoặc yêu cầu liên quan đến Chính sách Quyền Riêng Tư, vui lòng liên hệ:</p>
        <p>Công ty TNHH TM&XD Hoàng Khải</p>
        <p>📍 Địa chỉ: Km329+500 Đồng Khoai, Phường Quảng Phú, Tỉnh Thanh Hoá, Việt Nam</p>
        <p><a href="mailto:info@hkoil.org">📧 Email: info@hkoil.org</a></p>
        <p><a href="https://www.hkoil.org" target="_blank" rel="noopener noreferrer">🌐 Website: https://www.hkoil.org</a></p>
      </section>

      <section>
        <h2>9. Cập nhật chính sách</h2>
        <p>HKOIL có thể cập nhật Chính sách Quyền Riêng Tư này theo từng thời điểm để phù hợp với quy định pháp luật hoặc thay đổi trong dịch vụ.</p>
        <p>Mọi phiên bản cập nhật sẽ được công bố công khai trên website chính thức của HKOIL và trong ứng dụng HKOIL KCLUB.</p>
        <p>Chính sách này có hiệu lực kể từ ngày công bố chính thức.</p>
      </section>
    </main>
  </div>
</template>

<script>
// Thay defineOptions bằng export default để tránh lỗi no-undef và đảm bảo tên component là multi-word
export default {
  name: 'PrivacyPolicyPage'
};
</script>

<style scoped>
.policy-page {
  padding: 28px 12px;
  display: flex;
  justify-content: center;
}
.container {
  width: 100%;
  max-width: 900px;
  background: #fff;
  border-radius: 10px;
  padding: 24px;
  box-shadow: 0 6px 24px rgba(0,0,0,0.06);
  color: #222;
  line-height: 1.6;
}
h1 { font-size: 20px; margin-bottom: 8px; color: #0b6b3f; }
h2 { font-size: 16px; margin-top: 18px; color: #166534; }
.intro { margin-bottom: 12px; color: #444; }
.contact { margin-top: 14px; font-weight: 600; }
.contact a {
  color: #0b6b3f;
  text-decoration: none;
}
.contact a:hover {
  text-decoration: underline;
}
@media (max-width:600px){ .container{ padding:16px } h1{font-size:18px} h2{font-size:15px} }
</style>